import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

//custom hook
const useActiveUser = () => {
  const { isActiveAs } = useSelector((state) => state.userState);
  const initialRole = isActiveAs !== undefined && isActiveAs !== null ? isActiveAs : undefined;
  const [activeUser, setActiveUser] = useState(initialRole);

  useEffect(() => {
    if (isActiveAs !== undefined) {
      setActiveUser(isActiveAs);
    }
  }, [isActiveAs]);

  return activeUser;
};

export default useActiveUser;